/** Loads `path` as a new page in place of the current history entry, so nothing in memory carries over. */
export const navigateWithPageLoad = (path: string) => window.location.replace(path);
